import { useSendPhoneValidationCodeAction } from '@actions/SendPhoneValidationCodeAction';
import { useState } from 'react';
import { useValidatePhoneValidationCodeAction } from '@actions/ValidatePhoneValidationCodeAction';
import { useNavigate } from 'react-router-dom';

export const useEditPhoneNumberController = () => {
  const { mutateAsync: sendCodeAction } = useSendPhoneValidationCodeAction();
  const { mutateAsync: validateCodeAction } = useValidatePhoneValidationCodeAction();
  const [phoneNumber, setPhoneNumber] = useState<string>('');
  const [error, setError] = useState(true);
  const [errorMessage, setErrorMessage] = useState<string | null>(null);
  const navigator = useNavigate();
  const onPhoneNumberChange = async (number: string, err: boolean, errMessage: string) => {
    setPhoneNumber(number);
    setErrorMessage(errMessage);
    setError(err);
  };
  const onSendVerificationCode = async () => {
    await sendCodeAction(phoneNumber);
    navigator('?showModal=verify');
  };

  const validateCode = async (code: string) => {
    const result = await validateCodeAction({ phoneNumber, code });
    if (result.statusCode && (result.statusCode === 500 || result.statusCode === 400)) {
      setError(true);
      setErrorMessage(result.message);
      return;
    }
    navigator('/profile?success=1');
  };
  const onResendCode = async () => {
    await sendCodeAction(phoneNumber);
  };
  const onTryDifferentNumber = async () => {
    navigator('?showModal=edit');
  };
  const onTryAgain = async () => {
    navigator('?showModal=edit');
  };

  const resetError = async () => {
    setError(false);
    setErrorMessage(null);
  };

  return {
    onPhoneNumberChange,
    onSendVerificationCode,
    phoneNumber,
    setPhoneNumber,
    error,
    errorMessage,
    validateCode,
    onResendCode,
    onTryDifferentNumber,
    onTryAgain,
    resetError,
  };
};
